import Vue from 'vue';
import VueI18n from 'vue-i18n';

import _ from '@/lib/lodash';
import jaso from '@/lib/jaso';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    '../locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = messages[locale] || {};
      messages[locale] = _.merge(messages[locale], locales(key));
    }
  });
  return messages;
}
const vueI18n = new VueI18n({
  locale: 'ko',
  fallbackLocale: ['en', 'ko'],
  silentFallbackWarn: true,
  dateTimeFormats: {
    year_month: {
      year: 'numeric',
      month: 'short'
    },
    date_with_wday: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'long'
    }
  },
  messages: loadLocaleMessages()
});

const orgInterpolate = vueI18n._formatter.interpolate;
vueI18n._formatter.interpolate = (message, values) => {
  const numberFormattedValues =
    typeof values === 'object'
      ? _.mapValues(values, v => (_.isNumber(v) ? v.toLocaleString() : v))
      : values;
  const texts = orgInterpolate.apply(vueI18n._formatter, [
    message,
    numberFormattedValues
  ]);

  const mergedTexts = texts.reduce((a, t) => {
    const isMergeable = typeof t === 'string' && typeof _.last(a) === 'string';
    if (isMergeable) a[a.length - 1] += t;
    else a.push(t);
    return a;
  }, []);

  return mergedTexts.map(t => (typeof t === 'string' ? jaso(t) : t));
};

export default vueI18n;
